export default "__VITE_ASSET__zICB2YkW__"